import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Item from './Item';

class ItemsList extends PureComponent {
  render() {
    const { items } = this.props;

    return items.map((item) => <Item key={item.itemNumber} item={item} />);
  }
}

ItemsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      itemNumber: PropTypes.string,
      quantity: PropTypes.number,
    }),
  ),
};

export default ItemsList;
